import { ModalEventHandler, ModalEvents } from '../../modal/events/modal_event_handler';
import { ProcessAPI } from 'lecom-api';

let lastDomFocus = null;

export const ModalActions = Reflux.createActions([
	'open',
	'openFinished',
	'close',
	'closeFinished'
]);

export const ModalStore = Reflux.createStore({
	listenables: [ModalActions],
	optionProps: [
		'dismissible',
		'opacity',
		'inDuration',
		'outDuration',
		'ready',
		'complete'
	],

	modalId: '',
	openerId: '',
	shouldOpen: false,
	options: {},
	openedModalIds: [],
	isScroll: null,

	onOpen: function(props, callback) {
		this.modalId = props.modalId;
		this.openerId = props.openerId;
		this.shouldOpen = true;
		this.shouldClose = false;
		this.buttons = props.buttons;
		this.description = props.description || '-';
		this.showButtonClose = props.showButtonClose,
		this.title = props.title || '';
		this.type = props.type;
		this.icon = props.icon;
		this.isScroll = props.isScroll;
		this.close = false;

		if(this.modalId && document.getElementById(this.modalId) && document.getElementById(this.modalId).style.display === "block"){
			return
		}

		if($(document.activeElement).parents(".realize-modal").length === 0)
			this.activeElement = document.activeElement;

		this.options = $.grep(Object.keys(props), (prop) => {
			return (this.optionProps.indexOf(prop) > 0);
		});

		if (this.isScroll !== false){
			ModalEventHandler.publish(ModalEvents.MODAL_OPEN, this.modalId);
		}

		if(this.modalId === 'help-text-modal'){
			lastDomFocus = document.activeElement;
		}

		this.trigger(this, callback);
	},

	focusAutoCompleteRender: function(id) {
		const elem = $(`#${id}`);
		const processAPI = ProcessAPI.currentProcess();
		const isMobile = processAPI.isMobile();

		if(elem.is(':visible') === true){
			if(elem.find('.h5-custom')[0])
				$(elem.find('.h5-custom')[0]).attr('tabindex', 0).focus();
				elem.find('a').attr('tabindex', 0);
		}

		if(document.querySelector(".modal-loader") && document.querySelector(".modal-loader").style.display !== 'block' && !isMobile){			
			const self = this;
			
			setTimeout(() => {
				const elem = $(`#${id}`);
				if(!elem.is(":visible") && document.querySelectorAll(".lean-overlay").length === 1){
					self.activeElement.click();
				}
			}, 700);
		}
	},

	onOpenFinished: function() {
		const processAPI = ProcessAPI.currentProcess();
		const isMobile = processAPI.isMobile();

		this.shouldOpen = false;

		if(this.openedModalIds.indexOf(this.modalId) < 0)
			this.openedModalIds.push(this.modalId);		

		if (this.isScroll !== false) {
			let heightModalPosition =$(`#${this.modalId}`).position().top;
			let autoCompletHeight = $(`#${this.modalId} .input-autocomplete .input-autocomplete__result`).height();
			let modalSearch = $(`#${this.modalId} .modalLupa`).is(':visible');

			if(autoCompletHeight !== undefined){
				let positionModal = heightModalPosition - autoCompletHeight;

				ModalEventHandler.publish(ModalEvents.MODAL_OPENED, this.modalId, positionModal);
			} else if(modalSearch){
				ModalEventHandler.publish(ModalEvents.MODAL_OPENED, this.modalId, heightModalPosition);
			} else {
				heightModalPosition -= 284;
				ModalEventHandler.publish(ModalEvents.MODAL_OPENED, this.modalId, heightModalPosition);
			}
		}

		this.trigger(this);
		setTimeout(() => { this.focusAutoCompleteRender(this.modalId)}, 600);
	},

	onClose: function(props, callback) {
		this.modalId = props.modalId;
		this.shouldOpen = false;
		this.shouldClose = true;
		this.isScroll = props.isScroll;
		this.close = true;

		if (this.isScroll !== false)
			ModalEventHandler.publish(ModalEvents.MODAL_CLOSE, this.modalId);

		this.trigger(this, callback);

		if (lastDomFocus)
			lastDomFocus.focus();

		lastDomFocus = null;
	},

	onCloseFinished: function() {
		const processAPI = ProcessAPI.currentProcess();
		const isMobile = processAPI.isMobile();

		this.shouldClose = false;
		this.openedModalIds.splice(this.openedModalIds.indexOf(this.modalId), 1);

		if(!this.close) {
			document.querySelectorAll(".realize-modal").forEach((modal) => {
				if(modal.style.display === "block"){
					setTimeout(()=>{
						$(modal).find('.h5-custom')[0].focus();
					}, 10);
				}
			});
		}

		if (this.isScroll !== false)
			ModalEventHandler.publish(ModalEvents.MODAL_CLOSED, this.modalId);		

		if(this.activeElement && !$(this.activeElement).attr('class').match("template") && $(document.activeElement).parents(".realize-modal").length === 0){
			this.activeElement.focus();
		}

		this.trigger(this);
	}

});

export default ModalStore;
